import { BigNumber } from "ethers";
import { SolanaVaultList, VaultList, VaultVersionList, } from "../constants/constants";
export var defaultVaultsData = Object.fromEntries(VaultVersionList.map(function (version) { return [
    version,
    Object.fromEntries(VaultList.map(function (option) { return [option, undefined]; })),
]; }));
export var defaultVaultAccountsData = Object.fromEntries(VaultVersionList.map(function (version) { return [
    version,
    Object.fromEntries(VaultList.map(function (option) { return [option, undefined]; })),
]; }));
export var defaultVaultActivitiesData = Object.fromEntries(VaultVersionList.map(function (version) { return [
    version,
    Object.fromEntries(VaultList.map(function (option) { return [option, []]; })),
]; }));
export var defaultVaultData = {
    responses: Object.fromEntries(VaultList.map(function (vault) { return [
        vault,
        {
            deposits: BigNumber.from("0"),
            vaultLimit: BigNumber.from("0"),
            vaultBalanceInAsset: BigNumber.from("0"),
            vaultMaxWithdrawAmount: BigNumber.from("0"),
            maxWithdrawAmount: BigNumber.from("0"),
        },
    ]; })),
    loading: true,
};
export var defaultV2VaultData = {
    responses: Object.fromEntries(VaultList.map(function (vault) { return [
        vault,
        {
            totalBalance: BigNumber.from(0),
            cap: BigNumber.from(0),
            pricePerShare: BigNumber.from(0),
            round: 1,
            lockedBalanceInAsset: BigNumber.from(0),
            depositBalanceInAsset: BigNumber.from(0),
            withdrawals: {
                shares: BigNumber.from(0),
                round: 1,
            },
        },
    ]; })),
    loading: true,
};
export var defaultSolanaVaultData = {
    responses: Object.fromEntries(SolanaVaultList.map(function (vault) { return [
        vault,
        {
            totalBalance: BigNumber.from(0),
            cap: BigNumber.from(0),
            pricePerShare: BigNumber.from(0),
            round: 1,
            lockedBalanceInAsset: BigNumber.from(0),
            depositBalanceInAsset: BigNumber.from(0),
            withdrawals: {
                shares: BigNumber.from(0),
                round: 1,
            },
        },
    ]; })),
    loading: true,
};
export var defaultV2VaultPriceHistoriesData = Object.fromEntries(VaultVersionList.map(function (version) { return [
    version,
    Object.fromEntries(VaultList.map(function (vault) { return [vault, []]; })),
]; }));
//# sourceMappingURL=vault.js.map